import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { questionnaireLoaded } from "@teamprevent/common/questionnaires/actions";
import { EMPLOYEE_SATISFACTION_SURVEY_KEY } from "@teamprevent/common/employeeSatisfactionSurvey/models";

import { employeeSatisfactionSurveyApi } from "./employeeSatisfactionSurveyApi";
import { LOAD_EMPLOYEE_SATISFACTION_SURVEY } from "./actionTypes";

export const loadEmployeeSatisfactionSurvey = (customerId: string, taskId: string) => {
    return async (dispatch: Dispatch) => {
        const response = await loadAndTrack(
            dispatch,
            LOAD_EMPLOYEE_SATISFACTION_SURVEY,
            employeeSatisfactionSurveyApi.loadQuestionnaire(customerId, taskId)
        );
        const questions = response?.data?.questions ?? [];
        dispatch(questionnaireLoaded({ questions, questionnaireKey: EMPLOYEE_SATISFACTION_SURVEY_KEY }));
    };
};
